"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const FilterOptionWrapper = _styledComponents.default.li.withConfig({
  displayName: "FilterOption__FilterOptionWrapper",
  componentId: "design-system__sc-8yb9hv-0"
})(["& > a{display:block;text-decoration:none;margin:0.25rem 0;color:", ";text-decoration:none;font-size:", ";width:100%;height:", ";line-height:", ";}& > a:hover{background-color:", ";}"], _BaseTheme.default.colors.black, _BaseTheme.default.type.size.tiny, _BaseTheme.default.distance.double, _BaseTheme.default.type.lineHeight.extra, _BaseTheme.default.colors.bluegray);

const FilterOption = _ref => {
  let {
    label,
    to,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(FilterOptionWrapper, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    key: label,
    to: to,
    onClick: onClick
  }, label));
};

FilterOption.propTypes = {
  label: _propTypes.default.string.isRequired,
  to: _propTypes.default.string,
  onClick: _propTypes.default.func
};
FilterOption.defaultProps = {
  to: '',
  onClick: null
};
var _default = FilterOption;
exports.default = _default;